import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import Select2 from "@Shared/components/inputs/select2";
import { LOAD_DOCUMENTS, LOAD_DOCUMENT_TYPES } from "@Broker/js/modules/clients/applications/documents/store/documents-actions";
import { mapActions } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SelectApplicationStep",
  components: {
    MaterialInput,
    Select2
  },
  props: {
    applicationId: {
      type: [String, Number],
      default: ""
    },
    applications: {
      type: Object,
      default: () => ({})
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  computed: {
    applicationSelectOptions() {
      return {
        placeholder: this.$t("file.messages.selectAnApplication"),
        allowClear: false
      };
    },
    computedApplications() {
      return _Object$values(this.applications);
    }
  },
  watch: {
    applicationId() {
      if (this.applicationId) this.loadDocuments();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [LOAD_DOCUMENTS, LOAD_DOCUMENT_TYPES])), {}, {
    formatData(data) {
      return _mapInstanceProperty(data).call(data, app => {
        app.text = `${this.$t("application.applicationID")}: ${app.applicationId}`;
        app.id = app.applicationId;
        return app;
      });
    },
    handleApplicationIdChange({
      id
    }) {
      this.$emit("change", id);
    },
    async loadDocuments() {
      const promises = [this.LOAD_DOCUMENTS({
        clientUsername: this.clientUsername,
        applicationId: _parseInt(this.applicationId)
      }), this.LOAD_DOCUMENT_TYPES()];
      _Promise.all(promises);
    }
  })
});